import React, { useEffect, useState } from "react";
import styles from "./Ticket.module.sass";
import cn from "classnames";
import { UseDisclosure } from "../../hooks/use-disclosure";
import Card from "../../components/Card";
import Table from "./Table";
import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import ticket from "../../i11/TicketingProvider";
import Form from "../../components/Form";
import Icon from "../../components/Icon";
import TextInput from "../../components/TextInput";
import { GetBrand, UpdateBrand } from "../../Services/lib/brand";
import Loader from "../../components/Loader";
const LIMIT = 8;

const TicketingProviders = () => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [nft, setNFT] = useState();
	const [licenseNumber, setLicenseNumber] = useState("");

	const [{ isLoading }, updateLNumber] = UseApi({
		service: UpdateBrand,
		successMsg: "Success",
	});
	const [{ data: dataBrand, isLoading: isLoadingG }, getBrand] = UseApi({
		service: GetBrand,
	});

	useEffect(() => {
		getBrand();
	}, []);
	const open = () => {
		onOpen();
	};
	const onUpdate = async () => {
		await updateLNumber({
			helpDeskLicenseNumber: licenseNumber,
		});
		getBrand();
	};

	return (
		<>
			{!isOpen ? (
				<Card
					className={cn(styles.card, { [styles.hidden]: isOpen })}
					title={ticket[locale].ticket_title}
					classTitle={cn("title-purple", styles.title)}
					classCardHead={cn(styles.head, { [styles.hidden]: isOpen })}
					head={
						<Form
							placeholder={ticket[locale].exp_search_placeholder}
							type="text"
							name="search"
							icon="search"
							required={false}
							// value={search}
						/>
					}
				>
					<Table open={open} />
				</Card>
			) : (
				<>
					<button className={styles.flex} onClick={() => onClose()}>
						<Icon name={"arrow-left"} size="16" />
						<p> {ticket[locale].help_desk}</p>
					</button>
					<Card
						className={cn(styles.card, { [styles.hidden]: isOpen })}
						title={ticket[locale].help_desk_about}
						classTitle={cn("title-blue", styles.title)}
						classCardHead={cn(styles.head, { [styles.hidden]: isOpen })}
					>
						<>
							<div>{ticket[locale].h_about_desc}</div>
							<br />
							<div>
								{ticket[locale].h_support}{" "}
								<a href="https://helpdesk.com/" target="_blank">
									{ticket[locale].h_url}
								</a>
							</div>
						</>
					</Card>
					<br />

					<Card
						className={cn(styles.card, { [styles.hidden]: isOpen })}
						title={ticket[locale].account_information}
						classTitle={cn("title-blue", styles.title)}
						classCardHead={cn(styles.head, { [styles.hidden]: isOpen })}
					>
						<TextInput
							label={ticket[locale].license_number}
							placeholder="abc.0"
							defaultValue={dataBrand?.helpDeskLicenseNumber || ""}
							onChangeInput={(e) => setLicenseNumber(e)}
						/>
						<div className={styles.endbutton}>
							<button className={cn("button")} onClick={onUpdate}>
								{isLoading && <Loader />}
								{ticket[locale].connect}
							</button>
						</div>
					</Card>
				</>
			)}
			{/* {nft && <NFTModal visible={isOpen} onClose={close} data={nft} ticket />} */}
			{/* <UPSAccount isOpen={isOpenUPS} onClose={oncCloseUPS} /> */}
		</>
	);
};

export default TicketingProviders;
